import { PENDENCIA_ASSINATURA_LOAD, PENDENCIA_ASSINATURA_UNLOAD } from "../../actions/Constants";

const INITIAL_STATE = { all: [] };

export default function pendenciaAssinatura(state = INITIAL_STATE, action) {
  switch (action.type) {
    case PENDENCIA_ASSINATURA_LOAD:
      return {
        ...state,
        all: action.payload ? action.payload : null,
      };
    case PENDENCIA_ASSINATURA_UNLOAD:
      return INITIAL_STATE;
    default:
      return state;
  }
}
